export function upperCaseWithBrandStrings(string) {

    if (!string) {
        return
    }

    const brandStringsLib = ['UX 300h', 'UX 300e', 'UX 300h', 'UX 300h AWD']
    let formattedString = string.toUpperCase()

    _.forEach(brandStringsLib, function(brandString) {
        formattedString = formattedString.replace(new RegExp(brandString.toUpperCase(),'g'), brandString);
    })

    return formattedString;
}